import { render, staticRenderFns } from "./DigitalMedia.vue?vue&type=template&id=937edb7a&"
import script from "./DigitalMedia.vue?vue&type=script&lang=js&"
export * from "./DigitalMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports